// @ts-nocheck
import style from "./index.module.scss";

import assets_cqjtu_png from "../../../assets/cqjtu.png";
import assets_logo_cqjtu_png from "../../../assets/logo.cqjtu.png";
import {Button, DotLoading, Form, Input, Toast} from "antd-mobile";
import React, {useEffect, useState} from "react";
import IUtil from "../../../util/IUtil";
import {validationApi} from "../../../api/validation";
import styles from "../Cas/index.module.scss";
import {useSearchParams} from "react-router-dom";

export default function Index() {
    const [form] = Form.useForm();
    const [encryptedUserId, setEncryptedUserId] = useState<string>()
    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();

    const onFinish = (values: any) => {
        IUtil.confirmDialog("是否提交？", () => {
            const data={encryptedUserId, ...form.getFieldsValue()}
            validationApi.cqjtuLdapLogin(data)
                .then(() => {
                    setLoading(true)
                    Toast.show({
                        content: "认证成功，即将跳转到学校企业中，如长时间未自动跳转，请退出企业微信后重新进入",
                        duration: 5000,
                    });
                    sleep(3000).then(()=>{
                        guarantee(String(data.username))
                    })
                })
                .catch((err) => {
                    console.log(err)
                })
        });
    };


    const guarantee=(number:string)=>{
        sleep(2000).then(()=>{
            validationApi.cqjtuGuarantee({number}).finally(()=>{
                guarantee(number)
            })
        })
    }

    useEffect(() => {
        let _encryptedUserId = searchParams.get('encryptedUserId') || undefined
        setEncryptedUserId(_encryptedUserId)
        if (!_encryptedUserId) {
            Toast.show({
                content: "系统发生错误",
                duration: 5000,
            });
        }
    }, [])

    if (!encryptedUserId || loading) {
        return <div className={styles.Main}><DotLoading color='currentColor'/></div>;
    }

    // document.title = "统一身份认证"
    return <>
        <div className={style.Main}>
            {/*背景*/}
            <div className={style.Main_logo}><img src={assets_logo_cqjtu_png}/></div>
            <div className={style.Main_bg}><img src={assets_cqjtu_png}/></div>

            <div className={style.Main_form}>
                <div className={style.Main_form_title}>账号登录 <div className={style.Main_form_title_underline}/></div>
                <Form
                    form={form}
                    layout='horizontal'
                    requiredMarkStyle='none'
                    onFinish={onFinish}
                    onFinishFailed={(error) => {
                        console.log({error});
                    }}
                    footer={
                        <>
                            <Button block shape="rounded" type='submit' size={"large"}
                                    style={{marginTop: "4px", background: 'rgb(40, 95, 168)'}}>
                                登 录
                            </Button>
                            <div className={style.Main_form_help}>
                                <a href="https://ids.cqjtu.edu.cn/retrieve-password/activationMobile/index.html#/home" >账号激活</a>    
                                <a href="https://i.cqjtu.edu.cn/customapp/sys/xsxhcxfront/#/index">新生登录说明</a>    
                                <a href="https://ids.cqjtu.edu.cn/retrieve-password/passwordMobile/index.html#/home">忘记密码？</a>    
                            </div>
                            <div className={style.Main_bottom}>Copyright © 2024 重庆交通大学</div>
                        </>
                    }>
                    <Form.Item name={"username"} rules={[{required: true}]} style={{marginBottom: '5%'}}>
                        <Input placeholder='账号' clearable/>
                    </Form.Item>
                    <Form.Item name={"password"} rules={[{required: true}]}>
                        <Input placeholder='密码' type="password" clearable/>
                    </Form.Item>
                </Form>
            </div>


        </div>
    </>
}

function sleep(time: number) {
    return new Promise((resolve) => setTimeout(resolve, time));
}